import { 
  HIDE_GEO_LOCATION, 
  SET_ACTIVE_BASE_LAYER, 
  SET_ACTIVE_GRAPH_LAYER, 
  SET_BBOX_MAP, 
  SET_SHOW_ACTIVE_GRAPH_LAYER, 
  SHOW_GEO_LOCATION 
} from '../actions/mapActions';

const initial_state = {
  activeBaseLayer: 'osm-tiles',
  activeBaseGraphe: '',
  showBaseGraphe: false,
  showGeoLocation: false,
  geolocation: [],
  bbox: []
};

const map = (state = initial_state, action) => {

  switch (action.type) {
    case SET_ACTIVE_BASE_LAYER:
      return {
        ...state, activeBaseLayer: action.activeBaseLayer
      };
    case SET_ACTIVE_GRAPH_LAYER:
      return {
        ...state, activeBaseGraphe: action.activeGraphLayer
      };
    case SET_SHOW_ACTIVE_GRAPH_LAYER:
      return {
        ...state, showBaseGraphe: action.showActiveGraphLayer
      };
    case SHOW_GEO_LOCATION:
      return {
        ...state,
        showGeoLocation: true,
        geolocation: action.position
      };
    case HIDE_GEO_LOCATION:
      return {
        ...state,
        showGeoLocation: false,
        geolocation: []
      };
    case SET_BBOX_MAP:
      return {
        ...state,
        bbox: action.bbox
      };
    default:
      return state;
  }
};

export default map;

